<div class="storm-menu-wrapper"
     [ngStyle]="{ 'width.px': 200 }"
>
  <button class="select-box"
          [matMenuTriggerFor]="menu"
          (menuClosed)="onMenuClosed()"
          (menuOpened)="onMenuOpened()"
          [ngClass]="{ 'active': isMenuOpened }"
          matTooltip="Storm Event"
          matTooltipPosition="below"
  >
    <div class="select-box-content">
      <div class="select-box-circle"
           [ngClass]="{ 'grey': !stormStatus.active,
                        'green': stormStatus.active
                      }"
      >
      </div>
      <div class="select-box-title"
           [ngClass]="{ 'grey': !stormStatus.active }"
      >
        @if (stormStatus.active) {
          <span>Storm Event Active</span>
        } @else {
          <span>No Active Storm</span>
        }
      </div>
    </div>

    <div class="select-box-dropdown-icon"
         [ngClass]="{ 'grey': !stormStatus.active }"
         [attr.aria-label]="isMenuOpened? 'Close Menu' : 'Open Menu'"

    >
      @if (!isMenuOpened) {
        <mat-icon>expand_more</mat-icon>
      } @else {
        <mat-icon>expand_less</mat-icon>
      }
    </div>
  </button>

  <mat-menu #menu="matMenu" class="select-box-menu">
    @if (!stormStatus.active) {
      <button mat-menu-item
              [ngStyle]="{ 'width.px': 200 }"
              (click)="startStorm()"
              class="select-box-menu-item"
      >
        <div class="content">
          <div class="select-box-menu-item-circle green">
          </div>
          <div>
            <div>Start Storm Event</div>
            <div class="secondary-label">Begin tracking a storm</div>
          </div>
        </div>
      </button>
    } @else {
      <button mat-menu-item
              [ngStyle]="{ 'width.px': 200 }"
              class="select-box-menu-item"
      >
        <div class="content">
          <div class="select-box-menu-item-circle green">
          </div>
          <div>
            <div>Storm Event Active</div>
            <div class="secondary-label">Since {{ stormStatus.eventCreated | date:'short' }}</div>
          </div>
        </div>
      </button>
    }

    <mat-divider></mat-divider>

    @if (stormStatus.active) {
      <button
        mat-menu-item
        (click)="endStorm()"
      >
        <mat-icon>save</mat-icon>
        End Storm
      </button>
    } @else {
      <button
        mat-menu-item
        [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, InsightsRoute.STORM_REPORT]"
      >
        <mat-icon>history</mat-icon>
        Review past storms
      </button>
    }

  </mat-menu>
</div>
